export const environment = {
  env: "acceptance",
  production: true,
  backendEndpoint: "https://tst-backend.hub.bizcuit.nl"
};
